import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import DayStartServices from "./DayStartServices";

const initialState = {
  dayStatus: false,
  isError: false,
  isSuccess: false,
  isSuccessDayStart: false,
  isSuccessDayEnd: false,
  isLoading: false,
  tillAmount: 0,
  message: "",
};

export const getDayStatus = createAsyncThunk(
  "dayStart/getDayStatus",
  async (_, thunkAPI) => {
    try {
      return await DayStartServices.getDayStatus();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const startDay = createAsyncThunk(
  "dayStart/startDay",
  async (openingBalance, thunkAPI) => {
    try {
      return await DayStartServices.startDay(openingBalance);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const closeDay = createAsyncThunk(
  "dayStart/closeDay",
  async (closingBalance, thunkAPI) => {
    try {
      return await DayStartServices.closeDay(closingBalance);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTillAmount = createAsyncThunk(
  "dayStart/getTillAmount",
  async (_, thunkAPI) => {
    try {
      return await DayStartServices.getTillAmount();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const dayStartSlice = createSlice({
  name: "dayStart",
  initialState,
  reducers: {
    RESET_DAYSTART(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isSuccessDayStart = false;
      state.isSuccessDayEnd = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getDayStatus.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getDayStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dayStatus = action.payload.dayStart;
      })

      .addCase(getDayStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(startDay.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(startDay.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessDayStart = true;
        state.dayStatus = action.payload.dayStart;
      })

      .addCase(startDay.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(closeDay.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(closeDay.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessDayEnd = true;
        state.dayStatus = action.payload.dayStart;
        toast.success(action.payload.message);
      })

      .addCase(closeDay.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getTillAmount.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getTillAmount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.tillAmount = action.payload;
      })

      .addCase(getTillAmount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_DAYSTART } = dayStartSlice.actions;
export const selectDayStatus = (state) => state.dayStart.dayStatus;
export const selectTillAmount = (state) => state.dayStart.tillAmount;
export const selectDayStartSuccess = (state) =>
  state.dayStart.isSuccessDayStart;
export const selectDayEndSuccess = (state) => state.dayStart.isSuccessDayEnd;

export default dayStartSlice.reducer;
